import { Search } from "@mui/icons-material";
import { Button, Grid, InputBase, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, createObject, getFullName, getLocalValue, handleApiError, IsSmallScreen, LoacalVariables, Method } from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";
import DealPop from "../../Deals/DealPop";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useForm } from "react-hook-form";
import DealsDrawyer from "../../Deals/DealsDrawyer";
import { EmailDrawyer } from "../../Emails/EmailDrawyer";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";

export const OverViewEmail: React.FC<any> = React.memo((props) => {
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getEmailPermission;
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const id = params?.id;
  const [open, setOpen] = React.useState(false);
  const [emailListData, setemaillistData] = useState<any>([])
  const [resetLoad, setResetLoad] = useState(false)
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [formComponent, setFormComponent] = useState<any>()
  const resetTrigger = useSelector((state: any) => state.components?.emailDataGrid?.resetTrigger);
  const isMobile = IsSmallScreen();
  useEffect(() => {

    const getEmails = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI('email/lead', Method.GET, null, id)
        setemaillistData(response || []);
      }
      catch (e) {
      }
    }
    getEmails();
  }, [resetTrigger])
  useEffect(() => {

    const getEmails = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI('email/lead', Method.GET, null, id)
        setemaillistData(response || []);
      }
      catch (e) {
      }
    }
    getEmails();
  }, [resetLoad])
  const handleEmail = async (data: any) => {
    try {
      if (data) {

        const response = await createObject('email/send', { toEmail: data?.toEmail, subject: data.subject, body: data.body, leadId: id })
        if (response?.errors) {
          const mess = handleApiError(response)
          showMessage(mess, 'error');
        }
        else if (response && response?.message) {
          dispatch(resetDataComponent('emailDataGrid'));
          showMessage(response.message, response.success === true ? 'success' : 'error')
        } else if (response?.id) {

          showMessage('Mail sent successfully', 'success')
        }
      }
    }
    catch (e) { }
    finally {

    }
  }
  const columns: IColumns[] = [

    {
      header: "Subject",
      fieldName: "subject",
      tooltip: true,
      type: 'default'
    },
    {
      header: "To",
      fieldName: "toEmail",
      tooltip: true,
      type: 'default',
      isHide: isMobile
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [view ? "View" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
    // {
    //   header: "Amount",
    //   fieldName: "amount",
    //   tooltip: true,
    //   type: 'default'
    // },
  ];

  const handleAction = async (action: string, row: any) => {
    if (action === "View") {
      const form: any = <EmailDrawyer
        id="emailAdd"
        data={row}
        emailId={row?.id}
        control={control}
        //  loading={loading}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}
      />
      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);

    }
  }
  const handleEmailsClick = () => {
    const form: any = <EmailDrawyer
      id="emailAdd"
      control={control}
      register={register}
      reset={reset}
      setValue={setValue}
      onCancel={() => { reset(); setOpen(false) }}
    />
    setFormComponent(form)
    setTimeout(() => {
      setOpen(true)
    }, 10);
  }
  return (
    <Grid>
      <Grid container spacing={2} sx={{ p: 0, borderRadius: 5 }}>
        {view ? <Grid item xs={12}>
          <WSDataGrid
            id="emailDataGrid"
            title="Emails"
            data={emailListData}
            columns={columns}
            addButton={{ label: 'New', color: 'secondary', }}
            onAddButtonClick={handleEmailsClick}
             isAccordian={true}
          />
        </Grid>
          : <PermissionDenied />}
      </Grid>
      {formComponent && <SwipeableDrawerForm anchor="right" title={'Send Email'} isMobile={isMobile}
        openForm={open}
        formComponent={<form onSubmit={handleSubmit(handleEmail)}>
          {formComponent}
        </form>}
        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

      />}

    </Grid>
  );
});
